module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBold.618089d.eot";